import React, { lazy, Suspense } from 'react';
import styled from 'styled-components';
import { HotelTariffCard } from '@lt/components';
import { useTranslation } from '@lt/localization';
import type { HotelRatesResultsProps } from '../Searcher/types';

const AboutRoomPopup = lazy(
  () =>
    import(
      /* webpackChunkName: "AboutRoomPopup" */ 'src/routes/Hotel/containers/AboutRoomPopup'
    ),
);

export const HotelRatesResults = ({
  items,
  searchedNights,
  onOfferClicked,
  onClickOpenFilters,
  onLeaveNotFullOffersSpan,
  onClickGallery,
  hotelFacilities,
  isWhiteLabel,
  customCashbackIconURL,
  customCashbackText,
  customCashbackTooltipText,
  activateCashbackForPartner,
  tourists,
  isSetDefaultFilters,
  isMobile,
  ...rest
}: HotelRatesResultsProps) => {
  const { t } = useTranslation();
  return (
    <StyledContainer {...rest}>
      {isSetDefaultFilters ? (
        <StyledNotFullOffers isMobile={isMobile}>
          {t('hotel.ratesResults.notFullOffersАccommodation_hotel')}
          {isMobile ? <br /> : ' '}
          {t('hotel.ratesResults.notFullOffersFilters')}
          <StyledSpan
            onClick={onClickOpenFilters}
            onMouseLeave={onLeaveNotFullOffersSpan}
            isMobile={isMobile}
          >
            {t('hotel.ratesResults.notFullOffersButton')}
          </StyledSpan>
        </StyledNotFullOffers>
      ) : null}
      {items.map((item) => (
        <StyledItemWrapper key={item.ID}>
          <HotelTariffCard
            room={item.room}
            mealTypes={item.meal_types}
            offers={item.offers}
            labels={item.labels}
            nights={searchedNights}
            hotelFacilities={hotelFacilities}
            onOfferClicked={onOfferClicked}
            bonusCount={activateCashbackForPartner ? item.bonus_count : null}
            cashbackIdentifier={item.cashback_identifier}
            customCashbackIconURL={customCashbackIconURL}
            customCashbackText={customCashbackText}
            customCashbackTooltipText={customCashbackTooltipText}
            isWhiteLabel={isWhiteLabel}
            tourists={tourists}
            isMobile={isMobile}
            onClickGallery={onClickGallery}
          />
        </StyledItemWrapper>
      ))}
      <Suspense fallback={null}>
        <AboutRoomPopup />
      </Suspense>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledItemWrapper = styled.div`
  margin-bottom: 10px;
  display: flex;
  width: 100%;
  border-radius: 6px;
  box-shadow: 0 10px 15px 0 rgba(216, 214, 204, 0.9),
    0 1px 2px 0 rgba(210, 208, 197, 0.9);
`;

const StyledNotFullOffers = styled.div<{ isMobile: boolean }>`
  width: 100%;
  height: ${({ isMobile }) => (isMobile ? '72' : '40')}px;
  background: #fffbe5;
  border-radius: 4px;
  color: #4d4d4d;
  margin-bottom: 4px;
  ${({ isMobile }) =>
    isMobile
      ? `
  padding: 12px;
  text-align: center;
  font-size: 14px;
  `
      : `font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
    `}
`;

const StyledSpan = styled.span<{ isMobile: boolean }>`
  color: #007aff;
  cursor: pointer;
  border: 0;
  ${({ isMobile }) => !isMobile && 'margin-left: 3px;'}
`;
